/**
 * 设置 LocalStorage
 * @param {string} key 键
 * @param {(string|Object|Array)} value 字符串或对象、数组
 * @param {number} [expire] 失效时间，秒为单位
 */
export const setLocalStorage = (key, value, expire) => {
  try {
    const expireTime = expire ? Date.now() + expire * 1000 : null
    localStorage.setItem(key, JSON.stringify({ value, expire: expireTime }))
  } catch (e) {
    // empty
  }
}

/**
 * 获得 LocalStorage
 * @param {string} key key
 * @param {boolean} readAndRemove 读取后删除
 * @return {(string|null)}
 */
export const getLocalStorage = (key, readAndRemove = false) => {
  try {
    const data = JSON.parse(localStorage.getItem(key))

    // 判断是否可能过期
    if (data.expire && data.expire < Date.now()) {
      return null
    }

    readAndRemove && removeLocalStorage(key)

    return data.value
  } catch (e) {
    return null
  }
}

/**
 * 移除 LocalStorage
 * @param {string} key key
 */
export const removeLocalStorage = (key) => {
  try {
    localStorage.removeItem(key)
  } catch (e) {
    // empty
  }
}

/**
 * 设置 sessionStorage
 * @param {string} key 键
 * @param {(string|Object|Array)} value 字符串或对象、数组
 * @param {number} [expire] 失效时间，秒为单位
 */
export const setSessionStorage = (key, value, expire) => {
  try {
    const expireTime = expire ? Date.now() + expire * 1000 : null
    sessionStorage.setItem(key, JSON.stringify({ value, expire: expireTime }))
  } catch (e) {
    // empty
  }
}

/**
 * 获得 sessionStorage
 * @param {string} key key
 * @param {boolean} readAndRemove 读取后删除
 * @return {(string|null)}
 */
export const getSessionStorage = (key, readAndRemove = false) => {
  try {
    const data = JSON.parse(sessionStorage.getItem(key))

    // 判断是否可能过期
    if (data.expire && data.expire < Date.now()) {
      return null
    }

    readAndRemove && removeLocalStorage(key)

    return data.value
  } catch (e) {
    return null
  }
}

/**
 * 移除 sessionStorage
 * @param {string} key key
 */
export const removeSessionStorage = (key) => {
  try {
    sessionStorage.removeItem(key)
  } catch (e) {
    // empty
  }
}



// WEBPACK FOOTER //
// ./src/utils/storage.js